import enLocale from './en'

export default {
  ...enLocale,

  language: 'Ngôn ngữ',
  confirm: 'Xác nhận',
  go: 'Đi',
  status: 'Trạng thái',
  balance: 'Số dư',
  cash: 'Tiền mặt',
  createNew: 'Tạo mới',
  home: 'Trang chủ',
  market: 'Thị trường',
  markets: 'Thị trường',
  portfolio: 'Danh mục',
  license: 'Giấy phép',
  withdraw: 'Rút',
  auditChecking: 'Đang kiểm tra',
  insufficientFunds: 'Không đủ tiền',
  buy: 'Mua',
  history: 'Lịch sử',
  seeMore: 'Xem thêm',
  theme: 'Chủ đề',
  network: 'Mạng',
  walletBalance: 'Số dư ví',
  collect: 'Nhận',
  approve: 'Phê duyệt',
  ticket: 'Giấy phép',
  category: 'Danh mục',
  sortBy: 'Sắp xếp theo',
  issue: 'Phát hành',
  detail: 'Chi tiết',
  stakingType: 'Tài sản thế chấp',
  stakingTypeInfo: 'Để tránh xác nhận kết quả sai, hãy stake token hoặc NFT hiện tại.',
  subscriptionAmount: 'Số lượng mua',
  subscription: 'Đăng ký',
  subscribe: 'Mua',
  max: 'Tối đa',
  marketClosed: 'Đã đóng cửa',
  deposit: 'Thêm',
  verifiedNFT: 'Kiểm tra giấy phép',
  select: 'Chọn',
  selected: 'Đã chọn',
  moreNFT: 'Nhận thêm giấy phép',
  forecastEvent: 'Sự kiện',
  subscribeEndDate: 'Ngày giao dịch cuối',
  specifyExpiryDate: 'Chọn ngày hết hạn',
  endDate: 'Ngày kết thúc',
  validityPeriod: 'Ngày hết hạn',
  marketEndDate: 'Ngày hết hạn',
  liquidityMin: 'Thanh khoản tối thiểu',
  premiumMin: 'Phí bảo hiểm tối thiểu',
  paymentCurrency: 'Đơn vị thanh toán',
  defaultOdds: 'Đòn bẩy mặc định',
  setDefaultOdds: 'Thiết lập đòn bẩy',
  minInvestAmout: 'Thiết lập mức đầu tư tối thiểu',
  depositMargin: 'Thêm thanh khoản',
  totalPayment: 'Tổng thanh toán',
  rewards: 'Phần thưởng',
  rewardRate: 'Tỉ lệ thưởng',
  release: 'Giải phóng',
  fee: 'Phí',
  marginFeeRate: 'Tỉ lệ phí',
  cdsInfoOne: 'Khi phát hành sản phẩm dự đoán, cần stake ký quỹ, thiết lập đòn bẩy và mức đầu tư tối thiểu.',
  cdsInfoTwo: 'Ký quỹ chưa tham gia có thể rút bất cứ lúc nào.',
  cdsInfoThree: 'Nếu có hơn 1 người kháng nghị, cơ chế quản trị cộng đồng sẽ quyết định kết quả.',
  deposited: 'Đã đầu tư',
  issued: 'Đã phát hành',
  depositedCDS: 'Sản phẩm đã đầu tư',
  totalProfit: 'Tổng lợi nhuận',
  allOrDeposited: 'Tổng/Đầu tư',
  rewardsOrProfit: 'Thưởng/Lợi nhuận',
  estimatedInvested: 'Ước tính/Đầu tư',
  profit: 'Lợi nhuận',
  yesterdayProfit: 'Lợi nhuận hôm qua',
  eventConfirming: 'Đang xác nhận sự kiện',
  appeal: 'Kháng nghị',
  appealing: 'Đang kháng nghị',
  appealFailed: 'Kháng nghị thất bại',
  occured: 'Đã xảy ra',
  notOccured: 'Chưa xảy ra',
  governanceMechanism: 'Khi số kháng nghị > 1, khởi động cơ chế quản trị.',
  appealLimit: 'Số lượng kháng nghị không quá một người.',
  waitResult: 'Chờ kết quả kháng nghị',
  frozenMargin: 'Ký quỹ bị đóng băng',
  marginBalance: 'Số dư ký quỹ',
  cancel: 'Hủy',
  defaultAhead: 'Xảy ra sớm',
  occur: 'Xảy ra',
  notOccur: 'Không xảy ra',
  stakingToChallenge: 'Stake để thách thức',
  challenged: 'Đã thách thức',
  checking: 'Đang kiểm tra',
  fail: 'Thất bại',
  endTime: 'Đếm ngược đến kết thúc',
  guaranteeing: 'Đang diễn ra',
  guaranteeingEvent: 'Dự đoán đang diễn ra',
  confirmsEventAdvance: 'Xác nhận xảy ra sớm',
  waitConfirmation: 'Chờ xác nhận',
  triggerEvent: 'Xác nhận đã xảy ra',
  notTriggerEvent: 'Xác nhận không xảy ra',

  appealInfoOne: 'Nếu phán quyết sai lệch, bạn có thể “Thách thức” để cộng đồng quyết định kết quả cuối cùng.',
  check: 'Kiểm tra',
  contentIllegal: 'Sự kiện dự đoán có nội dung không phù hợp. Vui lòng sửa lại.',
  subscribed: 'Sản phẩm đã đầu tư',
  receivingCompensation: 'Đang chờ',
  received: 'Tổng chi trả',
  receive: 'Nhận',
  compensationAmount: 'Số tiền bồi thường khi xảy ra',
  liquidity: 'Thanh khoản',
  injectLiquidity: 'Bơm thanh khoản',
  uRLContent: 'URL/Nội dung',
  resolutionSource: 'Nguồn tham chiếu',
  textareaInfo: 'Vui lòng mô tả ngắn gọn sự kiện này.',

  issuerResult: 'Kết quả của nhà phát hành',
  daoResult: 'Kết quả DAO',
  waitingGovernanceResult: 'Đang chờ kết quả quản trị.',
  eventFinished: 'Sự kiện đã kết thúc.',
  recycleTicket: 'Thu hồi giấy phép',
  eventCancelled: 'Sự kiện đã bị hủy.',
  challenge: 'Thách thức',
  share: 'Chia sẻ',
  USDT: 'USDT',
  donations: 'Quyên góp',

  issueMsgPleaseSelectLicense: 'Vui lòng chọn giấy phép',
  issueMsgLicenseCannotBeStaked: 'Giấy phép không thể stake',
  issueMsgNetworkNotConnected: 'Mạng chưa kết nối',
  issueMsgEventEmpty: 'Sự kiện trống',
  issueMsgSelectLicense: 'Chọn giấy phép',
  issueMsgLastTradingDateEmpty: 'Chưa chọn ngày giao dịch cuối',
  issueMsgExpirationDateEmpty: 'Chưa chọn ngày hết hạn',
  issueMsgOptionsEmpty: 'Tùy chọn không được để trống',
  issueMsgOptionsLessThanTwo: 'Cần ít nhất 2 tùy chọn',
  issueMsgOptionEmpty: 'Tùy chọn trống',
  issueMsgOptionRepeated: 'Tùy chọn trùng lặp',
  issueMsgLastTradingDateGreaterThanToday: 'Ngày giao dịch cuối phải sau hôm nay',
  issueMsgLastTradingDateGreaterThanExpirationDate: 'Ngày giao dịch cuối muộn hơn ngày hết hạn',
  issueMsgLicenseError: 'Lỗi giấy phép',
  issueMsgTicketError: 'Lỗi vé',
  issueMsgEventEndDateGreaterThanRentalEndDate: 'Ngày kết thúc {eventEndDate} muộn hơn ngày kết thúc thuê {rentalEndDate}',
  issueMsgInsufficientBalance: 'Số dư không đủ',
  issueMsgTransactionFailed: 'Giao dịch thất bại',
  issueMsgIssueSuccess: 'Phát hành thành công',
  issueMsgTransactionCancelled: 'Giao dịch đã hủy',

  short: {
    ...enLocale.short,
    confirmsEventAdvance: 'Xảy ra sớm',
    waitConfirmation: 'Chờ xác nhận',
    defaultChallenging: 'Xảy ra-Đang thách thức',
    notDefaultChallenging: 'Không xảy ra-Đang thách thức',
    defaultChallengeFailed: 'Xảy ra-Thách thức thất bại',
    notDefaultChallengeFailed: 'Không xảy ra-Thách thức thất bại',
    defaultWaitingResult: 'Xảy ra-Đang quản trị',
    notDefaultWaitingResult: 'Không xảy ra-Đang quản trị',
    defaultGovernanceMechanism: 'Xảy ra-Xác nhận bởi quản trị',
    notDefaultGovernanceMechanism: 'Không xảy ra-Xác nhận bởi quản trị',
  },

  wallet: {
    ...enLocale.wallet,
    openWallet: 'Mở ví',
    connectWallet: 'Kết nối ví',
    connectingWallet: 'Đang kết nối ví',
    connectYourWallet: 'Kết nối ví của bạn',
    disconnect: 'Ngắt kết nối',
    wrongNetwork: 'Sai mạng',
  },

  NFT: {
    ...enLocale.NFT,
    getPrediLicense: 'Nhận giấy phép Predi',
    referralRewards: 'Phần thưởng giới thiệu',
    mintYourLicence: 'Đúc giấy phép của bạn',
    usageRights: 'Quyền sử dụng',
    issuePredictionProducts: 'Phát hành sản phẩm dự đoán',
    governance: 'Quản trị',
    properties: 'Thuộc tính',
    tradable: 'Có thể giao dịch',
    rentable: 'Có thể cho thuê',
    usable: 'Có thể sử dụng',
    marketsToIssue: 'Thị trường có thể phát hành',
    times: 'Lần',
    availableTimes: 'Số lần khả dụng',
    ticketId: 'ID vé',
    cancelRentHint: 'Giấy phép đang cho thuê, hãy hủy trước khi bán.',
    seeMore: 'Xem thêm',
    sell: 'Bán',
    rent: 'Cho thuê',
    share: 'Chia sẻ',
    common: 'Phổ biến',
    scarcity: 'Khó tìm',
    attributive: 'Thuộc tính',
    numbers: 'Số hiệu phát hành',
    issueTip: 'Mỗi giấy phép phát hành 10 thị trường dự đoán',
    price: 'Giá',
    success: 'Thành công',
    getNFT: 'Nhận giấy phép thành công',
    issueCDS: 'Phát hành thị trường Predi',
    buyNow: 'Mua ngay',
    mintNow: 'Đúc ngay',
    rule: 'Quy tắc',
    comingSoon: 'Sắp ra mắt!',
    type: 'Loại',
    from: 'Từ',
    to: 'Đến',
    me: 'Tôi',
    rented: 'Đã cho thuê',
    sold: 'Đã bán',
    tabGetLicense: 'Nhận giấy phép',
    tabMyLicense: 'Giấy phép của tôi',
    bought: 'Đã mua',
    boughtProducts: 'Sản phẩm đã mua',
    investedProducts: 'Sản phẩm đã đầu tư',
    issuedProducts: 'Sản phẩm đã phát hành',
    positions: 'Vị thế',
    options: 'Tùy chọn',
    all: 'Tất cả',
    volume: 'Khối lượng',
    newest: 'Mới nhất',
    pending: 'Đang chờ',
    audit: 'Kiểm tra',
    loading: 'Đang tải',
    empowering: 'Trao quyền cho những người nhìn xa dự đoán tương lai',
    myPositions: 'Vị thế của tôi',
    challengeCredit: 'Tín dụng thách thức',
    challengeStatus: 'Trạng thái thách thức',
    succeed: 'Thành công',
    wait: 'Chờ',
    return: 'Quay lại',
    createYourOwnMarket: 'Tạo thị trường của bạn',
    waitChallenge: 'Sự kiện đang chờ thách thức',
    waitingGovernanceResult: 'Đang chờ kết quả quản trị',
    eventFinished: 'Sự kiện đã kết thúc',
    cancelled: 'Đã hủy',
    predictionProduct: 'Sản phẩm dự đoán',
    complaintCountdown: 'Đếm ngược khiếu nại',
    setResult: 'Thiết lập kết quả',
    recycleTicket: 'Thu hồi giấy phép',
    eventCancelled: 'Sự kiện đã bị hủy',
    auditChecking: 'Đang kiểm tra',
    insufficientFunds: 'Không đủ tiền',
    buyTicket: 'Mua vé',
    listYourToken: 'Niêm yết token của bạn',
  },

  claim: {
    ...enLocale.claim,
    title: 'Nhận PRDs miễn phí',
    subtitle: 'Nhận token PRDs với một lần nhấp',
    walletAddress: 'Địa chỉ ví',
    status: 'Trạng thái',
    connectWalletFirst: 'Hãy kết nối ví trước',
    eligibility: {
      claimed: 'Bạn đã nhận',
      eligible: 'Bạn đủ điều kiện nhận',
      error: 'Lỗi kiểm tra đủ điều kiện',
    },
    button: {
      claim: 'Nhận',
      alreadyClaimed: 'Đã nhận',
      connect: 'Kết nối',
    },
    footerNotice: 'Mỗi ví chỉ có thể nhận một lần. Hãy đảm bảo kết nối đúng mạng.',
    messages: {
      connectFirst: 'Hãy kết nối ví trước',
      claimSuccess: 'Nhận thành công!',
      claimFailed: 'Nhận thất bại, vui lòng thử lại sau',
      txCancelled: 'Giao dịch đã hủy',
      onlyOnce: 'Mỗi người dùng chỉ nhận một lần',
      insufficientBalance: 'Số dư hợp đồng không đủ, vui lòng thử lại sau',
    },
  },
  
  // Additional top-level keys from en.js
  inputSearchText: 'Vui lòng nhập nội dung tìm kiếm',
  predictionProduct: 'Sản phẩm dự đoán',
  listYourToken: 'Niêm yết token của bạn',
  description: 'Mô tả',
  positions: 'Vị thế',
  options: 'Tùy chọn',
  all: 'Tất cả',
  volume: 'Khối lượng',
  newest: 'Mới nhất',
  pending: 'Đang chờ',
  audit: 'Kiểm tra',
  loading: 'Đang tải',
  challengeCredit: 'Tín dụng thách thức',
  challengeStatus: 'Trạng thái thách thức',
  succeed: 'Thành công',
  wait: 'Chờ',
  return: 'Quay lại',
  waitChallenge: 'Sự kiện đang chờ thách thức',
  complaintCountdown: 'Đếm ngược khiếu nại',
  setResult: 'Thiết lập kết quả',
  issueParticipateUntil: 'Người dùng có thể tham gia sản phẩm này cho đến',
  specifyLastTradingDate: 'Chỉ định thời gian giao dịch cuối cùng',
  empowering: 'Trao quyền cho những người nhìn xa dự đoán tương lai',
  amount: 'Số tiền',
  createYourOwnMarket: 'Tạo thị trường của riêng bạn',
  
  licenses: 'Giấy phép',
  prediLicense: 'Giấy phép Predi',
  issuableQuantity: 'Số lượng có thể phát hành',
  disabled: 'Vô hiệu',
  battleImage: 'Hình ảnh bằng chứng',
  upload: 'Tải lên',
  showSample: 'Xem mẫu',
  battleInformation: 'Thông tin tranh chấp',
  baseToken: 'Token cơ sở',
  collateral: 'Tài sản thế chấp',
  currentLicense: 'Giấy phép hiện tại',
  predictionProject: 'Dự án dự đoán:',
  issueExpireIntro: 'Vào thời điểm hết hạn, những người chọn phương án đúng sẽ chia sẻ token từ pool sản phẩm dựa trên cổ phần tham gia của họ.',
  issueConfirmAdvance: 'Kết quả có thể được xác nhận trước bởi người phát hành, nếu sự kiện xảy ra trước thời điểm hết hạn.',
  issueChallengeWithin7Days: 'Nếu người tham gia không đồng ý với kết quả sự kiện được người phát hành xác nhận, họ có thể "Thách thức" trong vòng 7 ngày kể từ khi xác nhận.',
  issueAttention: 'Chú ý: Predi cam kết thúc đẩy trải nghiệm giải trí và xã hội. Mọi hình thức hoạt động liên quan đến cờ bạc đều bị nghiêm cấm trên nền tảng này.',
  eventSampleTitle: 'Sự kiện',
  issueSampleCrypto: '[Tiền điện tử] Phạm vi giá Bitcoin vào cuối năm 2025 sẽ là bao nhiêu?',
  issueSampleFinance: '[Tài chính] Quyết định lãi suất của Cục Dự trữ Liên bang Mỹ trong Q3 2025 sẽ là gì?',
  issueSampleTechnology: '[Công nghệ] Công ty nào sẽ ra mắt trợ lý robot AI tự động hoàn toàn đầu tiên?',
  issueSampleSports: '[Thể thao] Đội nào sẽ giành chức vô địch FIFA World Cup 2026?',
  issueSampleSociety: '[Xã hội] Nền tảng truyền thông xã hội nào sẽ có nhiều người dùng hoạt động hàng tháng nhất trong năm 2025?',
  issueSampleOthers: '[Khác] Chiến tranh Nga-Ukraine sẽ kết thúc khi nào?',
  issuerResult: 'Kết quả của nhà phát hành',
  daoResult: 'Kết quả DAO',
  predictionToken: 'Token dự đoán',
  issuer: 'Nhà phát hành',
  issuerProfit: 'Lợi nhuận của nhà phát hành'
}